import { ComponentProps } from 'react';

import { Text } from '@rbilabs/universal-components';
import { StyleSheet, View } from 'react-native';

import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { IConfigOffer, IImageFragment } from 'generated/sanity-graphql';
import { useConfigOfferDateRangeMessage } from 'hooks/loyalty/use-config-offer-date-range-message';
import { primitive } from 'styles/constants/primitives';

type SanityBlockRendererProps = ComponentProps<typeof SanityBlockRenderer>;

interface IWalmartPlusWeekOffer {
  title: SanityBlockRendererProps['content'];
  text: SanityBlockRendererProps['content'];
  image?: IImageFragment | null;
  badge?: IImageFragment | null;
  configOffer: Pick<IConfigOffer, 'rules'>;
}

export const WalmartPlusWeekOffer = ({
  title,
  text,
  image,
  badge,
  configOffer,
}: IWalmartPlusWeekOffer) => {
  const configOfferDateRange = useConfigOfferDateRangeMessage(configOffer);

  return (
    <View style={styles.offer}>
      <View style={styles.offerImage}>
        <Picture
          style={styles.offerImage}
          image={image}
          alt={image?.asset?.altText || 'Offer logo'}
        />
      </View>
      <View style={styles.offerContent}>
        <SanityBlockRenderer content={title} textProps={{ variant: 'headerThree', margin: 0 }} />
        <SanityBlockRenderer content={text} textProps={{ variant: 'copyTwo', margin: 0 }} />
        {configOfferDateRange && (
          <Text variant="copyTwo" fontSize={10} lineHeight="lg">
            {configOfferDateRange}
          </Text>
        )}
        <Picture
          image={badge}
          alt={badge?.asset?.altText || 'Walmart'}
          objectFitContain
          lazy={false}
          height={6}
          marginTop={1}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  offer: {
    flexDirection: 'row',
    borderRadius: 10,
    backgroundColor: primitive.$white,
    padding: 12,
    gap: 12,
    alignItems: 'center',
  },
  offerImage: {
    width: 96,
    height: 96,
  },
  offerContent: {
    flex: 1,
    justifyContent: 'center',
    gap: 4,
  },
});
